module.exports = __webpack_public_path__ + "img/orbit-card-total-txs.58d101e1.png";